import { render, staticRenderFns } from "./ModalVinculosEnderecos.vue?vue&type=template&id=3dc7cf30&"
import script from "./ModalVinculosEnderecos.vue?vue&type=script&lang=js&"
export * from "./ModalVinculosEnderecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports